module.exports = [
	{
		"key": "soder",
		"name": "Söder - söder",
		"spots": [
			{
				"name": "Kön till Trädgården",
				"lat": "59.304636",
				"lng": "18.077207"
			},
			{
				"name": "Trädgård på Spåret",
				"lat": "59.305822",
				"lng": "18.073623"
			},
			{
				"name": "Nyfiken Gul",
				"lat": "59.303852",
				"lng": "18.072498"
			},
			{
				"name": "Skanstull",
				"lat": "59.307896",
				"lng": "18.076091"
			},
			{
				"name": "Skansbron",
				"lat": "59.303494",
				"lng": "18.080023"
			}
		]
	},
	{
		"key": "sodernv",
		"name": "Söder - nordväst",
		"spots": [
			{
				"name": "Skinnarviksberget",
				"lat": "59.319983",
				"lng": "18.050985"
			},
			{
				"name": "Ivar Los Park",
				"lat": "59.320529",
				"lng": "18.061199"
			},
			{
				"name": "Monteliusvägen",
				"lat": "59.320764",
				"lng": "18.060457"
			},
			{
				"name": "Bastugatan - Bellmansgatan",
				"lat": "59.320439",
				"lng": "18.064533"
			},
			{
				"name": "Lundabron",
				"lat": "59.319593",
				"lng": "18.056167"
			}
		]
	},
	{
		"key": "soderno",
		"name": "Söder - nordost",
		"spots": [
			{
				"name": "Mosebacketerrassen",
				"lat": "59.318338",
				"lng": "18.074950"
			},
			{
				"name": "Mosebacke Torg",
				"lat": "59.317986",
				"lng": "18.074446"
			},
			{
				"name": "Katarina Kyrka",
				"lat": "59.316616",
				"lng": "18.078325"
			},
			{
				"name": "Mäster Mikaels gata",
				"lat": "59.317392",
				"lng": "18.080702"
			},
			{
				"name": "Fjällgatan",
				"lat": "59.317364",
				"lng": "18.085878"
			}
		]
	},
	{
		"key": "sodero",
		"name": "Söder - öst",
		"spots": [
			{
				"name": "Nytorget",
				"lat": "59.312357",
				"lng": "18.083300"
			},
			{
				"name": "Sofia Kyrka",
				"lat": "59.312077",
				"lng": "18.088448"
			},
			{
				"name": "Vitabergsparken",
				"lat": "59.310911",
				"lng": "18.091259"
			},
			{
				"name": "Skånegatan",
				"lat": "59.312328",
				"lng": "18.079959"
			},
			{
				"name": "Bondegatan",
				"lat": "59.312903",
				"lng": "18.079133"
			}
		]
	},
	{
		"key": "city",
		"name": "City",
		"spots": [
			{
				"name": "Kungsträdgården",
				"lat": "59.331378",
				"lng": "18.071487"
			},
			{
				"name": "Gustav Adolfs Torg",
				"lat": "59.329496",
				"lng": "18.069230"
			},
			{
				"name": "Berzeeli Park - Nybroviken",
				"lat": "59.332087",
				"lng": "18.076268"
			},
			{
				"name": "Strömbron",
				"lat": "59.328907",
				"lng": "18.073167"
			},
			{
				"name": "Blasieholmen",
				"lat": "59.328921",
				"lng": "18.076812"
			}
		]
	},
	{
		"key": "ostermalm",
		"name": "Östermalm",
		"spots": [
			{
				"name": "Stureplan",
				"lat": "59.336070",
				"lng": "18.072758"
			},
			{
				"name": "Humlegården",
				"lat": "59.339389",
				"lng": "18.072775"
			},
			{
				"name": "Kungsgatan",
				"lat": "59.335884",
				"lng": "18.065550"
			},
			{
				"name": "Kungliga Biblioteket",
				"lat": "59.337805",
				"lng": "18.071762"
			},
			{
				"name": "Brunkebergstunneln",
				"lat": "59.337174",
				"lng": "18.066027"
			}
		]
	},
	{
		"key": "vasastan",
		"name": "Norrmalm - Vasastan",
		"spots": [
			{
				"name": "Observatorielunden",
				"lat": "59.341897",
				"lng": "18.055298"
			},
			{
				"name": "Vanadislunden",
				"lat": "59.348650",
				"lng": "18.054354"
			},
			{
				"name": "Vasaparken",
				"lat": "59.341027",
				"lng": "18.045870"
			},
			{
				"name": "Stockholms stadsbibliotek",
				"lat": "59.343486",
				"lng": "18.055384"
			},
			{
				"name": "Spökparken",
				"lat": "59.340258",
				"lng": "18.056281"
			}
		]
	},
	{
		"key": "langholmen",
		"name": "Långholmen - södra Kungsholmen",
		"spots": [
			{
				"name": "Långholmens klippbad",
				"lat": "59.322786",
				"lng": "18.034289"
			},
			{
				"name": "Långholmsklippan",
				"lat": "59.321709",
				"lng": "18.019313"
			},
			{
				"name": "Västerbron",
				"lat": "59.324184",
				"lng": "18.027669"
			},
			{
				"name": "Rålambshovsparken",
				"lat": "59.328623",
				"lng": "18.025893"
			}
		]
	},
	{
		"key": "vkungsholmen",
		"name": "Västra Kungsholmen",
		"spots": [
			{
				"name": "Solstugans Terrass",
				"lat": "59.331846",
				"lng": "17.997409"
			},
			{
				"name": "Kristinebergsklipporna",
				"lat": "59.335706",
				"lng": "17.996300"
			},
			{
				"name": "Fredhällsparken",
				"lat": "59.331484",
				"lng": "18.005949"
			},
			{
				"name": "Hornsbergs strandpark",
				"lat": "59.340745",
				"lng": "18.008243"
			},
			{
				"name": "Hornsbergs strandpromenad",
				"lat": "59.339735",
				"lng": "18.017271"
			}
		]
	},
	{
		"key": "djurgarden",
		"name": "Skeppsholmen - Djurgården",
		"spots": [
			{
				"name": "Djurgårdsbron",
				"lat": "59.331118",
				"lng": "18.093823"
			},
			{
				"name": "Skeppsholmsbron",
				"lat": "59.327271",
				"lng": "18.079182"
			},
			{
				"name": "Södra Brobänken",
				"lat": "59.323921",
				"lng": "18.086052"
			},
			{
				"name": "Kastellparken",
				"lat": "59.322215",
				"lng": "18.089466"
			},
			{
				"name": "Gamla Djurgården",
				"lat": "59.323503",
				"lng": "18.099146"
			}
		]
	},
	{
		"key": "hornstull",
		"name": "Hornstull",
		"spots": [
			{
				"name": "Lasse i Parken",
				"lat": "59.318739",
				"lng": "18.030820"
			},
			{
				"name": "Hornstulls Marknad",
				"lat": "59.315018",
				"lng": "18.030724"
			},
			{
				"name": "Bergsunds Strand",
				"lat": "59.316648",
				"lng": "18.026533"
			},
			{
				"name": "Hornviksstigen",
				"lat": "59.313515",
				"lng": "18.035811"
			},
			{
				"name": "Tantolunden",
				"lat": "59.313004",
				"lng": "18.049235"
			}
		]
	},
	{
		"key": "frihamnen",
		"name": "Frihamnen",
		"spots": [
			{
				"name": "AccompliceHQ",
				"lat": "59.343251",
				"lng": "18.115881"
			},
			{
				"name": "Auktionsverket",
				"lat": "59.341262",
				"lng": "18.124212"
			}
		]
	},
	{
		"key": "danderyd",
		"name": "Danderyd",
		"spots": [
			{
				"name": "Centrum",
				"lat": "59.397905",
				"lng": "18.036204"
			},
			{
				"name": "Golfbanan",
				"lat": "59.400198",
				"lng": "18.029808"
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/json/spots_update.json
// module id = 129
// module chunks = 0